import { exportSuppliers, getSuppliers } from '@/apis/supplierAPI'

import { ISupplier } from '@/utils/types/model/supplier'
import { CLEAR_SUPPLIERS, EXPORT_SUPPLIERS, FETCH_SUPPLIERS, SET_SUPPLIER_LOADING } from './actions'

type TSupplierState = {
  suppliers: ISupplier[]
  totalRecords: number
  isLoaded: boolean
  isLoading: boolean
}

export default {
  state: {
    suppliers: [],
    totalRecords: 0,
    isLoaded: false,
    isLoading: false,
  },
  mutations: {
    [FETCH_SUPPLIERS]: (
      state: TSupplierState,
      payload: {
        suppliers: ISupplier[]
        totalRecords: number
      }
    ) => {
      state.suppliers = payload.suppliers
      state.totalRecords = payload.totalRecords
      state.isLoaded = true
      state.isLoading = false
    },
    [CLEAR_SUPPLIERS]: (state: TSupplierState) => {
      state.suppliers = []
      state.totalRecords = 0
      state.isLoaded = false
      state.isLoading = false
    },
    [SET_SUPPLIER_LOADING]: (state: TSupplierState, loading: boolean) => {
      state.isLoading = loading
    },
  },
  actions: {
    [FETCH_SUPPLIERS]: async (
      { commit }: { commit: Function },
      payload: {
        page?: number
        limit?: number
        supplierCode?: string
        sortBy?: string
        sortType?: string
      } = {}
    ) => {
      try {
        commit(SET_SUPPLIER_LOADING, true)
        const { page = 1, limit = 10, supplierCode = '', sortBy, sortType } = payload
        const response = await getSuppliers(page, limit, supplierCode, sortBy, sortType)
        if (!response) {
          throw new Error('No response from API')
        }
        commit(FETCH_SUPPLIERS, {
          suppliers: response.suppliers || [],
          totalRecords: response.totalRecords || 0,
        })
        return response
      } catch (err) {
        commit(SET_SUPPLIER_LOADING, false)
        throw err
      }
    },
    [EXPORT_SUPPLIERS]: async (
      { commit }: { commit: Function },
      payload: {
        sortBy?: string
        sortType?: string
      } = {}
    ) => {
      try {
        commit(SET_SUPPLIER_LOADING, true)
        const data = {
          ...(payload.sortBy && { sortBy: payload.sortBy }),
          ...(payload.sortType && { sortType: payload.sortType }),
        }
        const response = await exportSuppliers(data)
        commit(SET_SUPPLIER_LOADING, false)
        return response
      } catch (err) {
        commit(SET_SUPPLIER_LOADING, false)
        throw err
      }
    },
    [CLEAR_SUPPLIERS]: ({ commit }: { commit: Function }) => {
      commit(CLEAR_SUPPLIERS)
    },
  },
  getters: {
    getSuppliers: (state: TSupplierState) => state.suppliers,
    getSupplierTotalRecords: (state: TSupplierState) => state.totalRecords,
    isSupplierLoading: (state: TSupplierState) => state.isLoading,
    isSupplierLoaded: (state: TSupplierState) => state.isLoaded,
  },
}
